var T = /* @__PURE__ */ ((r) => (r.NONE = "none", r.LEFT = "left", r.RIGHT = "right", r.TOP = "top", r.BOTTOM = "bottom", r.MAIN = "main", r))(T || {});
export {
  T as P
};
